@let _collapsed = isCollapsed();
@let floating = isFloating();
@let showingCollapsed = showingCollapsedContent();
@let shouldFloat = floating || showingCollapsed;
@let collapsed = _collapsed && !showingCollapsed;
@let state =
  !collapsed
    ? shouldFloat
      ? 'floatExpanded'
      : 'flatExpanded'
    : shouldFloat
      ? 'floatCollapsed'
      : 'flatCollapsed';

@let minFloatTop = isWindowsOrLinuxElectron() ? '40px' : '0px';

<div
  class="mdw-aside fill-height relative"
  [attr.data-state]="state"
  [style.--aside-width.px]="width()"
  [style.--aside-collapsed.px]="collapseWidth()"
  [style.--anchor-right.px]="anchorRightPx()"
  [style.--anchor-left.px]="anchorLeftPx()"
  [style.--anchor-top.px]="anchorTopPx()"
  [style.--anchor-bottom.px]="anchorBottomPx()"
  [style.--min-float-top]="minFloatTop"
  [class.anchor-left]="anchor() === 'left'"
  [class.anchor-right]="anchor() === 'right'"
  [class.no-animation]="disableAnimation || isResizing()"
  [class.is-pinning]="isPinning()"
>
  @let collapsedTemplate = collapseTemplate();
  @if (collapsed) {
    @if (collapsedTemplate) {
      <div class="fill-height fill-width aside-content" (mouseenter)="mouseEnter()">
        <ng-container *ngTemplateOutlet="collapsedTemplate"></ng-container>
      </div>
    }
  } @else {
    <div
      class="fill-width aside-content"
      [class.floating]="shouldFloat"
      [class.surface-elevated]="shouldFloat"
      [class.border-radius-200]="shouldFloat"
      [class.no-animation]="isResizing()"
      [style.maxWidth.px]="width()"
      [style.height]="shouldFloat ? 'unset' : '100%'"
      [animate.enter]="shouldFloat ? 'float-enter' : 'flat-enter'"
      [animate.leave]="shouldFloat ? 'float-leave' : 'flat-leave'"
      (mouseleave)="mouseLeave()"
    >
      <div class="inner-content fill-height fill-width">
        <ng-content></ng-content>

        @if (showingCollapsedContent() && !isAutoCollapedOrAutoFloated()) {
          <button
            class="mdw-button mdw-secondary pin-button"
            [icon]="icons.Pin_Fill"
            (click)="pinSidebar()"
          ></button>
        }
      </div>
    </div>
  }
</div>
